import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { Loader } from '../../../common/loader/loader.jsx';
import OffersJsx from './offers.jsx'
import { toast } from 'react-toastify';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { nameRegex, postalCodeRegex } from '../../../../shared/helper.js';

export default class Offers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offerData: null,
            wholeData: null,
            resetPagination: false,
            subCategoryData: null,
            formData: {
                instituteName: '',
                productName: '',
                type: '',
                homeFeatured: '',
            },
            formError: {},
            formSubmitButtonDisable: true,
            isLoading: false,
            page: 1,
            expertData: [],
            checked: false

        }
    }


    componentDidMount = () => {
        this.getOffers()
        const token = JSON.parse(localStorage.getItem('token'));

        if (!token) {
            this.props.history.push("/admin");
        }
    }
    getOffers = () => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        const { instituteName, productName, type, homeFeatured } = this.state.formData;

        axios.get(`${baseURL}/institutes/filter-offers?page=${this.state.page}&perPage=10&instituteName=${instituteName}&offerName=${productName}&isFeatured=${homeFeatured}&planType=${type}`, {
            headers: {
                'x-access-token': token
            }
        }
        ).then(res => {
            this.setState({ offerData: res.data.data, isLoading: false })
            this.setState({ wholeData: res.data, isLoading: false })

        }).catch(err=>{
            this.setState({ isLoading: false })
          })
    }
    onPaginationButtonClick = (page) => {
        window.scrollTo(0, 0);
        this.setState({ page: page }, () => this.getOffers())
    }
    handleChange = (e,id) => {
        const { checked } = e.target
        this.setState({
            checked: checked
        })
        this.makeFeature(id, checked)
    }
    handleChange1 = (e,id) => {
        const { checked } = e.target
        this.setState({
            checked: checked
        })
        this.makeFeature1(id, checked)
    }
    handleChange2 = (e,id) => {
        const { checked } = e.target
        this.setState({
            checked: checked
        })
        this.makeFeature2(id, checked)
    }
    handleChange3 = (e,id) => {
        const { checked } = e.target
        this.setState({
            checked: checked
        })
        this.makeFeature3(id, checked)
    }
    makeFeature1 = (id, action) => {
        const token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isLoading: true });
        let data = {
            "isTopOffer": action
        }
        axios.put(`${baseURL}/instituteOffer/${id}/topOffer`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.getOffers()
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err?.response.data.error.message);
        })
    }
    makeFeature2 = (id, action) => {
        const token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isLoading: true });
        let data = {
            "isHomeFeatured": action
        }
        axios.put(`${baseURL}/instituteOffer/${id}/homeFeatured`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.getOffers()
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err?.response.data.error.message);
        })
    }
    makeFeature3 = (id, action) => {
        const token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isLoading: true });
        let data = {
            "isSponsor": action
        }
        axios.put(`${baseURL}/instituteOffer/${id}/sponsorOffer`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.getOffers()
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err?.response.data.error.message);
        })
    }
    onCatgoryClick = (value) => {
        const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId === Number(value))
        this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
    }

    onInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (name === 'category')
            this.onCatgoryClick(value)

        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            }
        } else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    }

    inputRegexValidation = (name, value) => {
        if (name === 'instituteName' || name === "productName")
            return nameRegex.test(value);
        if (name === 'postalCode')
            return postalCodeRegex.test(value);

        return true;
    };

    isFromSubmissionBlock = () => {
        let { productName } = this.state.formData;

        if (productName) {
            if (
                this.inputRegexValidation('productName', productName)
            ) {
                this.setState({
                    formSubmitButtonDisable: false
                });
            }
            else {
                this.setState({
                    formSubmitButtonDisable: true
                });
            }
        } else {
            this.setState({
                formSubmitButtonDisable: true
            });
        }
    };

    onTouchHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value === "") {
            this.setState({
                formError: {
                    ...this.state.formError,
                    [name]: "req",
                },
            });
        } else {
            if (!this.inputRegexValidation(name, value)) {
                this.setState({
                    formError: {
                        ...this.state.formError,
                        [name]: "regx",
                    },
                });
            }
        }
    };

    onSubmitButtonClick = () => {
        let token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isLoading: true });
        const { instituteName, productName, type, homeFeatured } = this.state.formData;
        axios.get(`${baseURL}/institutes/filter-offers?instituteName=${instituteName}&perPage=10&offerName=${productName}&isFeatured=${homeFeatured}&planType=${type}`, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.setState({ offerData: res.data.data, isLoading: false });
            this.setState({ wholeData: res.data, isLoading: false })
            this.setState({resetPagination:true},()=> this.setState({resetPagination:false}))
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err?.response.data.error.message);
        })
    }

    onViewProfieClick = (url) => {
        this.props.history.push(`/expertPpv/${url}`)
    }
    makeFeature = (id,action) => {
        const token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isLoading: true });
        let data = {
            "isFeatured": action
        }
        axios.put(`${baseURL}/instituteOffer/${id}/featured`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.getOffers()
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err?.response.data.error.message);
        })
    }


    render() {
        return (
            <div>
                <OffersJsx
                    offerData={this.state.offerData}
                    wholeData={this.state.wholeData}

                    subCategoryData={this.state.subCategoryData}
                    formData={this.state.formData}
                    onInputChange={this.onInputChange}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    formError={this.state.formError}
                    onTouchHandler={this.onTouchHandler}
                    formSubmitButtonDisable={this.state.formSubmitButtonDisable}
                    onSubmitButtonClick={this.onSubmitButtonClick}
                    expertData={this.state.expertData}
                    onViewProfieClick={this.onViewProfieClick}
                    handleChange={this.handleChange}
                    handleChange1={this.handleChange1}
                    handleChange2={this.handleChange2}
                    handleChange3={this.handleChange3}

                    resetPagination={this.state.resetPagination}
                    makeFeature={this.makeFeature}
                />
                {this.state.isLoading && <Loader />}
            </div>
        )
    }
}
